import useMenuUrl, { MenuItemWrap } from '../useMenuUrl';
import { SubMenuBody } from './SubMenuBody';

type Props = {
  onClose: () => void;
};
export const SubMenuProdGuide = (props: Props) => {
  const { onClose } = props;
  const { menuEnabled } = useMenuUrl({ type: 'menu' });
  return (
    <SubMenuBody>
      {menuEnabled('drive') && <MenuItemWrap menuId='drive' onClick={onClose} type='menu' />}
      {menuEnabled('hmi') && <MenuItemWrap menuId='hmi' onClick={onClose} type='menu' />}
      {menuEnabled('reducer') && <MenuItemWrap menuId='reducer' onClick={onClose} type='menu' />}
      {menuEnabled('linear-motor') && <MenuItemWrap menuId='linear-motor' onClick={onClose} type='menu' />}
      {menuEnabled('drive-panel-selector') && (
        <MenuItemWrap menuId='drive-panel-selector' onClick={onClose} type='menu' />
      )}
    </SubMenuBody>
  );
};
